/**
 * Calendar + recurring-event domain types (F2).
 *
 * Pure data only — no I/O. A `CalendarEvent` carries a discriminated
 * `Recurrence` union describing when it repeats. Recurrence expansion
 * lives in `./recurrence.ts`. Persistence (server-first) is handled by
 * the agent's UserDataStore namespace `calendar`.
 */
export const EMPTY_CALENDAR_DATA = { events: [] };
//# sourceMappingURL=types.js.map